export default [
  {
    path: '/Login',
    name: 'Login',
    component: () => import('@/views/auth/login/Login.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/:symbol([A-Za-z]+)/Login',
    name: 'SchoolLogin',
    component: () => import('@/views/auth/login/Login.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/ForgotPassword',
    name: 'ForgotPassword',
    component: () => import('@/views/auth/login/Login.vue'),
    props: {
      isShowLogin: false,
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/BindPhone',
    name: 'BindPhone',
    component: () => import('@/views/auth/bind/BindPhone.vue'),
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: '/ForceResetPassword',
    name: 'ForceResetPassword',
    component: () => import('@/views/auth/password/ForceResetPassword.vue'),
    meta: {
      requiresAuth: false,
    },
  },

]

